/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ConfidenceScores, SentimentTypes } from 'src/languageStudio/core/services/textAnalytics/textAnalyticsSwaggers';
import { SentenceType } from 'src/packages/analyzed-conversation-viewer/lib/esm';

export const getDuration = (durationStr: string): SentenceType['duration'] => {
    const durationSplit = durationStr.split('M');

    return {
        minutes: durationSplit.length > 1 ? Number(durationSplit[0].substring(2)) : 0,
        seconds: Number(
            Number(
                durationSplit[durationSplit.length - 1].substring(
                    durationSplit.length > 1 ? 0 : 2,
                    durationSplit[durationSplit.length - 1].length - 2
                )
            ).toFixed()
        )
    };
};

export const getSentiment = (sentiment: ConfidenceScores): SentimentTypes => {
    const maxSentiment = Math.max(sentiment.negative, sentiment.neutral, sentiment.positive);

    if (maxSentiment === sentiment.negative) {
        return 'negative';
    }

    if (maxSentiment === sentiment.neutral) {
        return 'neutral';
    }

    return 'positive';
};
